import { familyByKey } from "../../utils/semanticColors";

// Shared color plumbing for the sitewide alert surfaces. Alert colors are
// data-driven (semantic family key stored per alert), so they're applied as
// inline styles from the family's vivid hex — same pattern as order tags.

export const familyOf = (alert) =>
  familyByKey(alert?.color_family) || familyByKey("blue");

const hexToRgb = (hex) => {
  const h = (hex || "").replace("#", "");
  if (h.length !== 6) return null;
  return [
    parseInt(h.slice(0, 2), 16),
    parseInt(h.slice(2, 4), 16),
    parseInt(h.slice(4, 6), 16),
  ];
};

// Translucent wash of the family color — layered over var(--surface) so it
// reads correctly in both light and dark themes.
export const tintOf = (hex, alpha = 0.12) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return "transparent";
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
};

// Ink color for text sitting ON a vivid family background. Yellow (and any
// other high-luminance vivid) needs dark ink; the rest take white.
export const inkOn = (hex) => {
  const rgb = hexToRgb(hex);
  if (!rgb) return "rgba(255, 255, 255, 0.98)";
  const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
  return luminance > 0.62 ? "rgba(15, 23, 42, 0.9)" : "rgba(255, 255, 255, 0.98)";
};
